/*
    作業者を選択するリスト（サジェスト付き）
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import ReactSelect, { SingleValue, ActionMeta } from "react-select";
import { PlantTeamMember, Member } from "../../redux/memberSlice";
export type ProcCodeSelectProp = {
  // ラベル
  label: string;
  // 作業者
  selectMenberId: string;
  // 工場コード
  plantCode: string;
  // 加工コード==所属コード（チーム）
  teamCode: string;
  // 作業者が選択された場合のイベント処理
  handleMemberChange: (
    selectedOption: SingleValue<any>,
    actionMeta: ActionMeta<any>
  ) => void;
};

export const MemberSuggestSelect: React.FC<ProcCodeSelectProp> = ({
  label,
  selectMenberId,
  plantCode,
  teamCode,
  handleMemberChange,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "select-member-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  //
  const plantTeamMember: PlantTeamMember[] = useSelector(
    (state: RootState) => state.member.plant_team_member
  );
  const orgMembers: Member[] = useSelector(
    (state: RootState) => state.member.original_member
  );
  //
  let members: Member[] | undefined = undefined;
  if (teamCode) {
    const teams = plantTeamMember.find(
      (d) => d.plant_code === plantCode
    )?.teams;
    members = teams?.find((d) => d.proc_code === teamCode)?.members;
  } else {
    members = orgMembers.filter((d) => d.branch_code === plantCode);
  }

  const defaltMemberList = [{ value: "", label: "-" }];
  const filteredMemberList =
    members?.map(({ member_id, name }) => ({
      value: member_id,
      label: name,
    })) || [];
  const options = [...defaltMemberList, ...filteredMemberList];

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <ReactSelect
        inputId={id}
        value={options.find((item) => item.value === selectMenberId)}
        options={options}
        onChange={handleMemberChange}
        noOptionsMessage={() => ""}
        placeholder=""
        className="react-select-container"
        classNamePrefix="react-select"
      />
    </>
  );
};
